"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GnosisSafeProxyFactoryWeb3Contract {
    constructor(contract) {
        this.contract = contract;
    }
    getAddress() {
        return this.contract.options.address;
    }
    async createProxy({ safeMasterCopyAddress, initializer, saltNonce, options }) {
        var _a, _b;
        let txResponse;
        if (saltNonce) {
            txResponse = this.contract.methods
                .createProxyWithNonce(safeMasterCopyAddress, initializer, saltNonce)
                .send(options);
        }
        else {
            txResponse = this.contract.methods
                .createProxy(safeMasterCopyAddress, initializer)
                .send(options);
        }
        const txResult = await new Promise((resolve, reject) => txResponse.once('receipt', (receipt) => resolve(receipt)).catch(reject));
        const proxyAddress = (_b = (_a = txResult.events) === null || _a === void 0 ? void 0 : _a['0'].raw) === null || _b === void 0 ? void 0 : _b.data.substr(-40);
        if (!proxyAddress) {
            throw new Error('Safe Proxy was not deployed correctly');
        }
        return '0x' + proxyAddress;
    }
    encode(methodName, params) {
        return this.contract.methods[methodName](...params).encodeABI();
    }
}
exports.default = GnosisSafeProxyFactoryWeb3Contract;
//# sourceMappingURL=GnosisSafeProxyFactoryWeb3Contract.js.map